import React, { FC } from 'react';
import styled from 'styled-components';

import { useIntlMessage } from '../Common/IntlMessage';

const Wrapper = styled.div`
    position: relative;
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    margin: auto;
    p{
        text-align:justify;
    }
    ol{
        padding-inline-start: 1rem;
        list-style:decimal;
    }
    li{
        margin: 0px 0px 0.2rem;
    }
    ul{
        li{
            margin-top: 1em;
            list-style:disc;
            padding-inline-start: 1rem;
        }
    }
    h3{
        margin-bottom: 1rem;
        margin-top: 1.5rem;
        font-weight: 600;
    }
    h4{
        margin-top: 0.6rem;
        margin-bottom: 0.4rem;
        font-weight: 600
    }
    h5{
        margin-bottom: 0.45rem;
        margin-top: 0.45rem;
        font-weight: 600;
    }
`;

export const TermsAndConditionsContainer: FC<React.PropsWithChildren<unknown>> = () => {
    const { intlFormatMessage } = useIntlMessage();
    return (
        <Wrapper>
            <div dangerouslySetInnerHTML={{
                __html: intlFormatMessage({ id: 'terms.termsAndConditions' })
            }} />
        </Wrapper>
    );
};

export default TermsAndConditionsContainer;
